<div class="sts-signin-text">
  <span *ngIf="Prefix" [innerHtml]="Prefix | stsSafeHtml"></span>
  <p *ngIf="needHelpTitle">
    <a [ngStyle]="linkStyles" routerLink="/account/help">{{needHelpTitle}}</a>
  </p>
  <p *ngIf="forgotPasswordTitle">
    <a [ngStyle]="linkStyles" routerLink="/account/forgot-password/">{{forgotPasswordTitle}}</a>
  </p>
  <span *ngIf="Suffix" [innerHtml]="Suffix | stsSafeHtml"></span>
</div>
